import { COLORS, NAME_SOUND_HOVER, useGameSounds } from "@educaplay/core";
import BackIcon from "../../icons/Back";
import classes from "./BackButton.module.scss";
import useVideo from "../../hooks/useVideo";

const SECONDS_BACK_PROGRESS = 10;

export default function BackButton(props) {

    const { show = false } = props;
    const gameSound = useGameSounds();
    const { progress, setProgress } = useVideo();

    const backProgress = () => {
        const backProgress = Math.max(progress - SECONDS_BACK_PROGRESS, 0);
        setProgress(backProgress);
    }


    return (
        <>
            {show && (
                <button className={classes.btnback} onClick={backProgress} onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)} >
                    <BackIcon size={24} color={COLORS.primary} />
                </button>
            )
            }
        </>)
}